import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Avatar, Box, Button, Divider, Grid, Tooltip, Typography,Skeleton} from '@mui/material';
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import moment from 'moment';
import { createRef, useEffect, useMemo, useState,useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IState } from '../../../redux/reducers/rootReducers';
import CommonStyles from '../../common/CommonStyles';
import { TextBoxLatest } from '../../common/TextBoxLatest/TextBoxLatest';
import Card from "../../common/card";
import CustomModalDialog from "../../common/customDialog";
import { TicketFilterSSP } from '../TicketFilter/TicketFilterSSP';
import CustomDialog from '../../common/dialog/CustomDialog';
import BasicButton from '../../common/button/BasicButton';
import { updateNewTicket } from '../../../services/dashboard/dashboard.service';
import { SnackBar } from '../../../services/AssetsManagement/AssetType';
import { SspStatusUrl, getTicketStatus } from '../../../redux/actions/SystemManagement/TicketStatus';
import ViewIcon from "../../../assest/icons/viewIcon.svg";
import LanguageData from "../../../configs/LanguageData.json";
import { useNavigate } from 'react-router-dom';
import NoDataFound from '../../common2/NoDataFound';
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import WebFormValues from '../../Dashboard/TicketManagement/TicketDashboardWidgets/WebFormValues';
import { getUserWebFormById } from '../../../redux/actions/WebForms/webForms';
import RichEmailPreviewer from '../../common2/RichEmailPreviewer'
import InfiniteScroll from "react-infinite-scroll-component"; 
import { Popover } from "@mui/material";
import { ContactPopover } from "../../TicketManagementSystem/Modules/TicketCard";
import {getSSpTicketByID,getSSpTicketTimelineByID,getSSpTicketAssetByID,getAttachmentByID} from "../../../../src/services/dashboard/dashboard.service" 
import { ConvertZ } from "../../helpers/helperFunctions";
import SSPAssetList from './SSPAssetList'
import SSPTimeline from './SSPTimeline'
import FileViewFromBlobUrl from '../../MobileComponents/MobileCommon/FileView';
import timeSpanToReadbleFormat from "../../../util/timeSpanToReadbleFormat";
import AddAttachmentBlobWithPreview from "../../EmailTemplates/AddAttachmentBlobWithPreview";
import {fileUploadServiceForBloeStorage} from "../../../services/fileUpload/FileUpload";
import { a } from 'react-spring';
const page_size = 16;
// checking if description is in html formate 
const isHtml = (text = "") => /<\/?[a-z][\s\S]*>/i.test(text);

// converting to plaintext
const htmlToPlainText = (html = "") => {
  if (!html) return "-";
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

const WorkCenterNew = () => {
  const loggedContact = useSelector((state: IState) => state?.ContactsReducer?.loggedContact);
  const defaultService: any = useSelector(
    (state: IState) => state?.ContactsReducer?.DefaultService
  );
  const classes = CommonStyles();
  const navigate = useNavigate()
  return (
    <>
      {loggedContact?.id ?
        <TicketFilterSSP userId={loggedContact.id} loggedContact={loggedContact}
          extraFeatures={<>
          
            <div
              onClick={() => {
                navigate(`/viewService?id=${defaultService?.id}`);
              }}
            >
              + Report a fault
            </div></>}>
          <><WorkCenterLayout /></>
        </TicketFilterSSP>
      : <>Loading...</>}
    </>
  )
}
const WorkCenterLayout = () => {
  const tickets = useSelector((state: IState) => state?.ContactsReducer?.contactTickets);
  const [visible, setVisible] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [primaryContact, setPrimaryContact] = useState<any>(null);
  const [secondaryContact, setSecondaryContact] = useState<any>(null);
  const hoverTimer = useRef<any>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement>,
    contact: any,
    secondary: any
    ) => {
    setAnchorEl(event.currentTarget);
    setPrimaryContact(contact);
    setSecondaryContact(secondary);
  };

  // console.log("PrimaryContact SecondaryContact", primaryContact, secondaryContact)
  
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const popOpen = Boolean(anchorEl);

   useEffect(() => {
    if (tickets?.length) {
      setVisible(tickets.slice(0, page_size));
      setHasMore(tickets.length > page_size);
    }
  }, [tickets]);

  const fetchMore = () => {
    const nextLength = visible.length + page_size;
    const newData = tickets.slice(0, nextLength);

    setTimeout(() => {
      setVisible(newData);
      if (newData.length >= tickets.length) {
        setHasMore(false);
      }
    }, 300);

  };

  const classes = CommonStyles();
  const [viewId, setViewId] = useState<number>(0);
  
  const [tabValue, setTabValue] = useState("1");

const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
  setTabValue(newValue);
};

  if (tickets.length === 0) {
   return <NoDataFound />
  }

  return (
    <>
    <InfiniteScroll
      dataLength={visible.length}
      next={fetchMore}
      hasMore={hasMore}
      loader={
  <Grid container spacing={1} className="pt-1">
    {Array.from({ length: 4 }).map((_, i) => (
      <Grid item xs={12} md={3} key={i}>
        <Box
          sx={{
            borderRadius: 2,
            p: 2,
            background: "#f5f7fb",
            boxShadow: 1,
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center" gap={1}>
              <Skeleton variant="circular" width={30} height={30} />
              <Skeleton width={80} height={20} />
            </Box>
            <Skeleton width={70} height={22} />
          </Box>

          <Box mt={2}>
            <Skeleton width="80%" height={18} />
            <Skeleton width="90%" height={18} />
            <Skeleton width="60%" height={18} />
            <Skeleton width="70%" height={18} />
          </Box>

          <Box mt={2}>
            <Skeleton variant="rectangular" width={40} height={28} />
          </Box>
        </Box>
      </Grid>
    ))}
  </Grid>
}
    >
      <Grid container className="pt-1" spacing={1}>
          {visible.map((i: any, index: number) => {
            const {
              title,
              description,
              ticketId,
              ticketStatus,
              contacts,
              secondaryContacts,
              dueDateTimeFormatted,
            } = i?.ticketLogs;

            return (
              <Grid item md={3} xs={12} key={index}>
                <Card
                  styleProp={classes.cardStyle}
                  customHeader={
                    <Box
                      className={`${classes.row} flx-gap-10 ${classes.alignItemsCenter} ${classes.justifyBetween} ${classes.w100}`}
                    >
                      <div>
                        <Avatar className="sml-avatar" sx={{ height: 30, width: 30 }} alt="" src={`${contacts?.profilePicturePath || ""}`} onMouseEnter={(e) => handlePopoverOpen(e, contacts, secondaryContacts)}/>
                      </div>

                      <Typography variant="body2" className={classes.title}>
                        ID : {ticketId}
                      </Typography>
                      <Box>
                        <Tooltip title="Ticket Status">
                          <Typography
                            variant="body2"
                            className={`${classes.title} ${classes.ticketCardTags}`}
                          >
                            {ticketStatus?.displayName || "-"}
                          </Typography>
                        </Tooltip>
                      </Box>
                    </Box>
                  }
                  cardBody={
                    <Box className="txt-ellipsis">
                      <Typography className="pb-5p" variant="body1" sx={{fontSize:'12px !important'}}>
                        Subject : {title}
                      </Typography>
                      <Typography className="pb-5p" variant="body1" sx={{fontSize:'12px !important'}}>
                        {/* Description : {description} */}
                        Description :{" "}
                          {isHtml(description)
                            ? htmlToPlainText(description)
                            : description}
                      </Typography>
                      <Typography className="pb-5p" variant="body1" sx={{fontSize:'12px !important'}}>
                        {/* Service : {i?.contactAid?.name} */}
                         Service : {i.contactAid?.name ? i.contactAid?.name : '---'}
                      </Typography>
                      <Typography variant="body1" sx={{fontSize:'12px !important'}}>
                        Due Date :{" "}
                        <b className={classes.primaryTxt}>
                          {dueDateTimeFormatted
                              ? moment(dueDateTimeFormatted, "DD/MM/YYYY HH:mm").format("DD-MM-YYYY")
                              : "---"}
                        </b>
                      </Typography>
                    </Box>
                  }
                  cardFooter={
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        // justifyContent: "space-between",
                      }}
                    >
                      <Box style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                        {ticketStatus?.name !== "Closed" && (
                          <Tooltip title="View Details">
                            <img
                              src={ViewIcon}
                              alt="view icon"
                              onClick={() => {
                                setViewId(i.id);
                              }}
                            />
                          </Tooltip>
                        )}
                      </Box>
                    </Box>
                  }
                />
              </Grid>
            );
          })}    
      </Grid>
  </InfiniteScroll>
      <Popover
        open={popOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          onMouseLeave: handlePopoverClose,
        }}
      >
        {primaryContact && (
          <Box sx={{ p: 1 }}>
            <ContactPopover
              contactInfo={primaryContact}
              secContactInfo={secondaryContact}
            />
          </Box>
        )}
      </Popover>
    {viewId !== 0 && (
  <ViewModal id={viewId} setViewId={setViewId} />
)}
    </>
  )
}
export const ViewModal = ({id=0,setViewId}:any) => {
  type Ticket = {
  totalEffort?: any;
};
  const classes = CommonStyles();
  const descRef = useRef<any>(null);
  const closeRef = useRef<any>();
  const quickRef = useRef<any>(null);
  const dispatch= useDispatch()
  const [ticketStatus,setTicketStatus]=useState<any>({})
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [ticketRes,setTicketRes] = useState<Ticket>({});
  const [timeline,setTimeLine] = useState<any[]>([]);
  const [attachments,setAttachments] = useState<any[]>([]);
  const [assetList,setAssetList] = useState<any[]>([]);
   const [attachmentList, setAttachmentList] = useState<any>([]);
   const [clicked, setClicked] = useState(false);
   const [quick,setQuick] = useState(false);
   const [closeclicked, setCloseCliked] = useState(false);
   const [updateModal,setUpdateModal] = useState(false);
  const [quickAttachmentList, setQuickAttachmentList] = useState<any>([]);
  useEffect(() => {
    const getTicketData = async(id:any) => {
    const [res1,res2] = await Promise.all([getSSpTicketByID(id),getAttachmentByID(id)])
    if(res1){
      setTicketRes(res1)
    }
     if(res2){
      setAttachments(res2)
    }
  }
  getTicketData(id)
  },[])
  const filterd:any = []
  filterd[0] = ticketRes

  const [webformVal, setWebformVal] = useState<any|null>(null); 
  const [tabValue, setTabValue] = useState<string>("1");
  
const handleTabChange = async (event: React.SyntheticEvent, newValue: string) => {
  setClicked(false)
  if(newValue === "2"){
    try{
    const TimeLine = await getSSpTicketTimelineByID(id)
     if(TimeLine){
      setTimeLine(TimeLine)
    }
    }
    catch (err) {
      console.error("Failed to get Timeline:", err);
    }
  }
  if (newValue==="3" && webformVal === null) {
    try {
      const data = await getUserWebFormById(filterd[0].ticketLogs?.webformId);
      // console.log("Webform Data:", data);
      setWebformVal(data);
    } catch (err) {
      console.error("Failed to fetch webform fields:", err);
    }
  }
   if(newValue === "4"){
    try{
    const Asset = await getSSpTicketAssetByID(id)
     if(Asset){
      setAssetList(Asset)
    }
    }
    catch (err) {
      console.error("Failed to get Asset Details:", err);
    }
  }
  setTabValue(newValue);
};

 
  const updateTicket = async (id: any, payload: any) => {
    let newTicket: any = await updateNewTicket(payload, id, "user/Ticket");
    return newTicket;
  };
  const quickUpdate = () => {
     setQuick(true)
    if (!quickRef.current?.value?.trim()) {
      return;
    }
   
    const attachmentPaths = quickAttachmentList?.map((item: any) => {
    return {
      AttachmentPath: item.fileName ? item.fileName : item.attachmentPath,
    };
    });
    filterd[0].ticketLogs.note = quickRef.current.value
    filterd[0].ticketLogs.effort = "00:00:00"
    filterd[0].ticketLogs.isNotePrivate = false
    filterd[0].ticketLogs.ticketLogAttachmentsList = attachmentPaths;
    updateTicket(filterd[0].id, filterd[0]).then((res: any) => {
      if (res.status == 200) {
         res?.data?.ticketLogs?.ticketLogAttachmentsList?.map(
            (item: any, index: number) => {
              fileUploadServiceForBloeStorage(
                item?.attachmentPath,
                quickAttachmentList[index]?.formFile,
                (isDone: any, res: any) => {
                  if (isDone) {
                    console.log("inputFileHandler file uploaded", res);
                  } else {
                    console.log("inputFileHandler file failed", res);
                  }
                }
              );
            }
          );
        setViewId(0)
        // setDeleteModalStatus(false);
        dispatch(SnackBar(`${LanguageData.SUCCESS} ${res?.data?.id} ${LanguageData.TICKET_UPDATED} `, 'success'));

      }
    });
  }


  const submitForm = () => {
     setClicked(true)
    if (!descRef.current?.value?.trim()) {
      return;
    }
   
    const attachmentPaths = attachmentList?.map((item: any) => {
    return {
      AttachmentPath: item.fileName ? item.fileName : item.attachmentPath,
    };
    });
    filterd[0].ticketLogs.note = descRef.current.value
    filterd[0].ticketLogs.effort = "00:00:00"
    filterd[0].ticketLogs.isNotePrivate = false
    filterd[0].ticketLogs.ticketLogAttachmentsList = attachmentPaths;
    updateTicket(filterd[0].id, filterd[0]).then((res: any) => {
      // console.log("ticketCreation res", res);
      if (res.status == 200) {
         res?.data?.ticketLogs?.ticketLogAttachmentsList?.map(
            (item: any, index: number) => {
              fileUploadServiceForBloeStorage(
                item?.attachmentPath,
                attachmentList[index]?.formFile,
                (isDone: any, res: any) => {
                  if (isDone) {
                    console.log("inputFileHandler file uploaded", res);
                  } else {
                    console.log("inputFileHandler file failed", res);
                  }
                }
              );
            }
          );
        setViewId(0)
        // setDeleteModalStatus(false);
        dispatch(SnackBar(`${LanguageData.SUCCESS} ${res?.data?.id} ${LanguageData.TICKET_UPDATED} `, 'success'));

      }
    });
    // descRef.current.value = ""
  }
  const handleClose =()=>{
    setDeleteModalStatus(true)

    // console.log("Hiiiii")
  }
  useEffect(() => {
    dispatch(getTicketStatus(getTicketStatusCB,SspStatusUrl));
  }, []);

  const getTicketStatusCB = (res: any = []) => {
    setTicketStatus(res[1])
    // console.log("popopopo", res)
  }
   const checkIsTicketClassified = () => {
    console.log("filterd[0]?.ticketLogs", filterd[0])
    const { priorityId, statusId, categoryId } = filterd[0]?.ticketLogs;
    return priorityId && statusId && categoryId ? true : false;
  };

  const addUpdateHandler = () => {
    setUpdateModal(true);
  };
  const onTicketClose = () => {
    setCloseCliked(true)
    const payload = { ...filterd[0] }
     if (!closeRef.current?.value?.trim()) {
      return;
    }

    // debugger
    // console.log('onTicketClose', payload)

    if (payload.ticketLogs) {
     payload.ticketLogs.statusId = ticketStatus.filter((ele: any) => ele.name === "Closed" && ele.type==="TicketStatus")?.[0]?.id;
      payload.ticketLogs.ticketStatus = ticketStatus.filter((ele: any) => ele.name === "Closed"&& ele.type==="TicketStatus")?.[0]
      payload.ticketLogs.note = closeRef.current.value
    }
    // dispatch(updateTicket(payload.id, payload))//taskObj
    updateTicket(payload.id, payload).then((res: any) => {
      // console.log("ticketCreation res", res);
      if (res.status == 200) {
        setViewId(0)
        dispatch(SnackBar(`${LanguageData.SUCCESS} ${res?.data?.id} ${LanguageData.TICKET_CLOSED}`, 'success'));

      }
    });
    // console.log('onTicketClose', payload)
  };
  return (
    <>
      {
        <CustomModalDialog
          title=""
          id="upgradeModal"
          isOpen={true}
          onClose={() => {
            setViewId(0);
          }}
          fullScreen="true"
          headerContent={
            <div style={{ display: "flex", justifyContent: "space-between" }}> 
              <Typography variant="caption" style={{ fontSize: "18px" }}>
                <b>Ticket Info - {id}</b>
              </Typography>
              <Box style={{ display: "flex", gap: "10px", alignItems: "center" }}>
               {tabValue == "2" &&  ( 
                <Button onClick={addUpdateHandler} variant="outlined" style={{marginTop:"20px"}} sx={{fontSize:{xs:'10px',sm:'0.875rem'}}}>
                  <EditRoundedIcon /> Add Update
                </Button>       
              )}
              <Button variant="contained" color="primary" sx={{fontSize:{xs:'10px',sm:'0.875rem'}}} style={{marginTop:"20px", color: "#ffffff"}} onClick={handleClose}>
                Close Ticket
              </Button>
              </Box>
              
            </div>
          }
          bodyContent={
            <Box className={classes.upgradePopupHolder}>
              <TabContext value={tabValue}>
              <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                }}>
                <TabList onChange={handleTabChange} className="tab-links">
                  <Tab label="Ticket Info" value="1" />
                   <Tab label="Timeline" value="2" />
                  {filterd[0]?.ticketLogs?.webformId > 0 && (
                    <Tab label="Webform Details" value="3" />
                  )}
                  <Tab label="Assets" value="4" />
                  
                </TabList>
                {/* {tabValue == "2" &&  (<Box className="ticket-view-action-btns" sx={{position:"absolute",right:'75px'}}>  
                  <Button onClick={addUpdateHandler}>
                    <EditRoundedIcon /> Add Update
                  </Button>
                              
                </Box>
                )} */}
                </Box>
                {tabValue == "2" && (<Box sx={{width:'200px',marginLeft:"auto",paddingTop:{xs:'20px',sm:'0'}}}>
                <Typography variant="subtitle2" sx={{fontSize:'16px'}}>
                  Total Effort : {" "}
                   {timeSpanToReadbleFormat(
                      ticketRes?.totalEffort
                        ? ticketRes?.totalEffort
                        : "-",
                      "effort"
                    )}
                </Typography>
              </Box>)}
              
                <Box className="p-1">
                  {tabValue === "1" && (
                    <Grid container spacing={3}>
                      <Grid item xs={6} md={4}>
                        <Typography className={classes.textWithSpanTitle} sx={{fontSize:'14px !important'}}>
                          <span className='blueTitle'>Subject :</span>{" "}
                          {filterd[0]?.ticketLogs?.title || "-"}
                        </Typography>
                        <Typography className={classes.textWithSpanTitle} sx={{fontSize:'14px !important'}}>
                          <span className='blueTitle'>Description :</span>{" "}
                          {/* {filterd[0]?.ticketLogs?.description || "-"} */}
                           {(filterd[0]?.sourceCode == 'Email')
                            ?  <RichEmailPreviewer body={filterd[0]?.ticketLogs?.body||""} height={300}/>
                            : filterd[0]?.ticketLogs?.description}

                          
                        </Typography>
                        <Typography className={classes.textWithSpanTitle} sx={{fontSize:'14px !important'}}>
                          <span className='blueTitle'>Created Date :</span>{" "}
                          {ConvertZ(filterd[0]?.createdDateTime) ||  "----"}
                        </Typography>
                        <Typography className={classes.textWithSpanTitle} sx={{fontSize:'14px !important'}}>
                          <span className='blueTitle'>Due Date :</span>{" "}
                          {ConvertZ(filterd[0]?.ticketLogs?.dueDateTime) ||
                            "----"}
                        </Typography>
                        <Typography className={classes.textWithSpanTitle} sx={{fontSize:'14px !important'}}>
                          <span className='blueTitle'>Total Effort :</span>{" "}
                          {timeSpanToReadbleFormat(
                              ticketRes?.totalEffort
                                ? ticketRes?.totalEffort
                                : "-",
                              "effort"
                            )}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={4} className="bl-1">
                        <Typography className={classes.textWithSpanTitle} sx={{fontSize:'14px !important'}}>
                          <span className='blueTitle'>Service :</span>{" "}
                          {filterd[0]?.contactAid?.name || "---"}
                        </Typography>
                        <Typography className={classes.textWithSpanTitle} sx={{fontSize:'14px !important'}}>
                          <span className='blueTitle'>Ticket Status :</span>{" "}
                          {filterd[0]?.ticketLogs?.ticketStatus?.displayName ||
                            "-"}
                        </Typography>
                        <Typography className={classes.textWithSpanTitle} sx={{fontSize:'14px !important'}}>
                          {!filterd[0]?.ticketLogs?.isNotePrivate && (
                            <>
                              <span className='blueTitle'>Note : </span>
                              <div>{filterd[0]?.ticketLogs?.note || "-"}</div>
                            </>
                          )}
                        </Typography>
                        <Typography className="pb-1 pt-1 blueTitle">Attachments :</Typography>
                        {attachments.length > 0 ? (
                          <Box sx={{display:'flex',gap:'15px',padding:'15px 0 0 10px',flexWrap:'wrap'}}>
                             {attachments?.map((i: any, index: number) => {
                              return (
                                <Box key={index}>
                                  <FileViewFromBlobUrl url={i.attachmentPath} />
                                </Box>
                              );
                            })}
                          </Box>
                          ) : (
                            <Typography>
                              No Attachments Found
                            </Typography>
                          )}
                      </Grid>
                    
                        <Grid item xs={6} md={4} className="bl-1">
                          Add Quick Update
                          <br />
                          <div style={{ marginTop: "5px" }}>
                            <TextBoxLatest
                            multiline={true}
                            placeholder="Enter the Note"
                            title={"Note"}
                            ref={descRef}
                            isMandotary={true}
                            errorMsg={"Please Enter Note"}
                            isError={clicked && descRef.current?.value === "" ? true : false}
                            name="desc"
                          />
                          <AddAttachmentBlobWithPreview
                              accept={
                                ".pdf,.doc,.docx,.jpg,.jpeg,.png,.zip,.txt,.xls,.xlsx,.mp4,.bmp"
                              }
                              type="Attachment"
                              isAttachmentOnFly={false}
                              isShowBtn={true}
                              attachmentList={attachmentList}
                              setAttachmentList={setAttachmentList}
                              btnLabel="Add Attachments"
                            />
                        </div>
                        <Box className="text-center">
                          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                          <Button
                            className={`${classes.btn} ${classes.btnSubmit}`}
                            variant="contained"
                            onClick={submitForm}
                          >
                            {"Update"}
                          </Button>
                        </Box>
                      </Grid> 
                    </Grid>
                  )}
              {tabValue === "2" && (
                <Box>
                 <Dialog
                    open={updateModal}
                    onClose={() => {
                            setUpdateModal(false);
                            setQuick(false);
                          }}
                    maxWidth="sm"
                    fullWidth
                  >
                    <DialogContent>
                       <DialogTitle sx={{p:0}}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                          Add Quick Update

                          <IconButton onClick={() => {
                            setUpdateModal(false);
                            setQuick(false);
                          }}>
                            <CloseIcon />
                          </IconButton>
                        </Box>
                      </DialogTitle>
                     <Grid item xs={12}>
                        <div style={{ marginTop: "5px" }}>
                          <TextBoxLatest
                            multiline={true}
                            placeholder="Enter the Note"
                            title={"Note"}
                            ref={quickRef}
                            isMandotary={true}
                            errorMsg={"Please Enter Note"}
                            isError={quick && quickRef.current?.value === "" ? true : false}
                            name="quick"
                          />
                          <AddAttachmentBlobWithPreview
                              accept={
                                ".pdf,.doc,.docx,.jpg,.jpeg,.png,.zip,.txt,.xls,.xlsx,.mp4,.bmp"
                              }
                              type="Attachment"
                              isAttachmentOnFly={false}
                              isShowBtn={true}
                              attachmentList={quickAttachmentList}
                              setAttachmentList={setQuickAttachmentList}
                              btnLabel="Add Attachments"
                            />
                        </div>
                        <Box className="text-center">
                          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                          <Button
                            variant="outlined"
                            onClick={() => setUpdateModal(false)}
                            sx={{minWidth:'110px'}}
                          >
                            {"Cancel"}
                          </Button>
                          <Button
                            className={`${classes.btn} ${classes.btnSubmit}`}
                            variant="contained"
                            onClick={quickUpdate}
                          >
                            {"Update"}
                          </Button>
                        </Box>
                      </Grid>

                    </DialogContent>
                  </Dialog>
                 <SSPTimeline data={timeline} />
                </Box>
              )}
              {tabValue === "3" && (
                <Box>
                  <WebFormValues
                    webformFieldList={webformVal?.webformFieldList || []}
                    values={filterd[0]?.ticketLogs?.webformValues}
                  />
                </Box>
              )}
               {tabValue === "4" && (
                <Box>
                  <SSPAssetList data={assetList}/>
                </Box>
              )}

                </Box>
              </TabContext>
             
            </Box>
          }
        />
      }
       
    
      {deleteModalStatus && (
        <CustomDialog
        className="close-ticket-modal"
          heading={`Close Ticket ID : ${id} `} 
          body={
            <>
              Are you sure want to close this ticket ?
              <Box>
                <br />
                <TextBoxLatest
                  multiline={true}
                  placeholder="Enter the Note"
                  title={"Note"}
                  ref={closeRef}
                  isMandotary={true}
                  errorMsg={""}
                  isError={closeclicked && !closeRef.current?.value?.trim() ? true : false}
                  name="close"
                />
                {closeclicked && !closeRef.current?.value?.trim() ? (<span style={{ color: "#d32f2f",fontSize:'12px' }}>Please Enter Note</span>) : ""}
                
              </Box>
            </>
          }
          open={deleteModalStatus}
          handleClose={() => {
            setDeleteModalStatus(false);
          }}
          footer={
            <>
              <div
                style={{ display: "flex", flexDirection: "row", gap: 20 }}
                className={classes.btnWrapperModal}
              >
                <BasicButton
                  onClick={(e: any) => {
                    setDeleteModalStatus(false);
                     setCloseCliked(false)
                  }}
                  type={"Cancel"}
                  // isLoading={false}
                  // isDisabled={false}
                  color="primary"
                  size="large"
                  label="Cancel"
                  variant={"outlined"}
                  endIcon={false}
                />
                <BasicButton
                  onClick={() => {
                    onTicketClose();
                  }}
                  type={"submit"}
                  // isLoading={false}
                  // isDisabled={false}
                  color="primary"
                  size="large"
                  label="Close"
                  variant={"contained"}
                  endIcon={false}
                />
              </div>
            </>
          }
        />
      )}
    </>
  );
}
// const mapStateToProps = (state:IState) => {
//     return ({
//       ticketsList : state?.ContactsReducer?.contactTickets,
//       loggedContact: state?.ContactsReducer?.loggedContact
//     })
//   };
export default WorkCenterNew;//connect(mapStateToProps)(WorkCenterNew);